import React from "react";
import {SmileType} from "./Images";

export interface ImageProps {
    type: SmileType
    url: string
    data: string
    onClipboard: (type: SmileType, url: string) => void
}

export const Image = (props: ImageProps) => {
    return (
        <div className="tab-image">
            <a
                href={props.url}
                onClick={e => {
                    e.preventDefault()

                    props.onClipboard(props.type, props.data)
                }}
            >
                <img src={props.url} alt=""/>
            </a>
        </div>
    )
}